module.exports = __webpack_public_path__ + "69cf430356b43bf52483adb8504c137a.png";